import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAction, useAtom } from '@reatom/react'
import { useLocation, useHistory } from 'react-router-dom'

import { Header } from '@bfg/components/static/header'
import Footer from '@bfg/components/static/footer'
import { StepsToolbar } from '@bfg/components/StepsToolbar'
import { Screen } from '@bfg/components/Screen'
import { MobileStepsToolbarUnified } from '@bfg/components/MobileStepsToolbar'
import { AppConfigAtom, ChangeVersion } from '@bfg/atoms/AppConfig'
import { ExperimentsProvider } from '@bfg/contexts/ExperimentsContext'
import { PaymentTypeProvider } from '@bfg/contexts/PaymentTypeContext'
import { PaywallVariantProvider } from '@bfg/contexts/PaywallVariantContext'
import { WalletTypeProvider } from '@bfg/contexts/WalletTypeContext'
import { PaymentStateProvider } from '@bfg/contexts/PaymentStateContext'
import { SubscriberStateProvider } from '@bfg/contexts/SubscriberStateContext'
import { StepsProvider } from '@bfg/contexts/StepsContext'
import { AppConfigProvider } from '@bfg/contexts/AppContext'
import { AndroidWebViewProvider } from '@bfg/contexts/AndroidWebViewContext'
import useExperimentsResolver from '@bfg/effects/experiments'

const Wrapper = () => {
  const experiments = useExperimentsResolver()
  const { t, i18n } = useTranslation()
  const history = useHistory()
  const appState = useAtom(AppConfigAtom)
  const changeVersion = useAction(v => ChangeVersion(v))

  document.body.dir = i18n.dir()
  document.title = t('meta.title')
  document.querySelector('meta[name="description"]').content = t('meta.description')
  const lang = i18n.language === 'en' ? `` : `${i18n.language}/`
  document.querySelector('link[rel="canonical"]').href = `https://babyfacegenerator.com/${lang.toLowerCase()}`

  const location = useLocation()

  const pagesWithoutCTA = [
    '/profile', '/profile/', '/contact-us', '/contact-us/',
  ]

  const [showToolbars, setShowToolbars] = React.useState(true)

  React.useEffect(() => {
    // console.log(experiments.aiExperiment)
    changeVersion(experiments.aiExperiment)
  }, [])

  React.useEffect(() => {
    const path = location.pathname
    setShowToolbars(!pagesWithoutCTA.includes(path))
  }, [location.pathname])

  return (
    <>
      <AppConfigProvider>
        <ExperimentsProvider>
          <PaywallVariantProvider>
            <PaymentTypeProvider>
              <WalletTypeProvider>
                <PaymentStateProvider>
                  <SubscriberStateProvider>
                    <StepsProvider>
                      <AndroidWebViewProvider>
                        <div className="wrapper">
                          <a className="btn btn-jump-to-content"
                             href="#main-content"
                             title={t('main.Skip Navigation')}
                          >{t('main.Skip Navigation')}</a>
                          <Header/>

                          <main id="main-content">
                            <div className="container">
                              {
                                !appState.isMobile &&
                                showToolbars && !(
                                  history.location.pathname === '/wiki'
                                  || history.location.pathname === '/wiki/'
                                ) &&
                                <StepsToolbar/>
                              }
                              <Screen/>
                              {
                                appState.isMobile &&
                                showToolbars &&
                                <MobileStepsToolbarUnified/>
                              }
                            </div>
                          </main>
                        </div>

                        <Footer/>
                      </AndroidWebViewProvider>
                    </StepsProvider>
                  </SubscriberStateProvider>
                </PaymentStateProvider>
              </WalletTypeProvider>
            </PaymentTypeProvider>
          </PaywallVariantProvider>
        </ExperimentsProvider>
      </AppConfigProvider>
    </>
  )
}

export default Wrapper